import axios from "../../../services/axios-config.js";

export async function updateCommissionedCompanyValue({ mapId, commissionValue }) {
  const res = await axios.post("/commissioned/companies/update-value", { mapId, commissionValue });
  return res?.data;
}
